import { Download } from 'lucide-react'
import { useEffect, useRef, useState } from 'react'
import { CSVLink } from 'react-csv'
import { type Headers } from 'react-csv/lib/core'

import { useGetPayoutMemberEligibilities } from 'components/hooks/partners/useGetPayoutMemberEligibilities'
import { IconButton } from 'slab'

const headers: Headers = [
  { label: 'First name', key: 'given_name' },
  { label: 'Last name', key: 'last_name' },
  { label: 'Eligible', key: 'eligible' },
  { label: 'Ineligible reason', key: 'ineligible_reason' },
  { label: 'Month', key: 'month' },
  { label: 'Commission', key: 'commission' },
]

const DownloadTopUpBreakdownButton = ({
  ledgerId
}: { ledgerId: string }) => {
  const csvLinkRef = useRef<CSVLink & HTMLAnchorElement & { link: HTMLAnchorElement }>(null)
  const [shouldFetch, setShouldFetch] = useState(false)
  const { data } = useGetPayoutMemberEligibilities(ledgerId, {
    enabled: shouldFetch
  })

  const onClick = () => {
    setShouldFetch(true)

    window.segment?.track('[TfB] Topup breakdown downloaded')
  }

  useEffect(() => {
    if (data) {
      csvLinkRef.current?.link.click()
      setShouldFetch(false)
    }
  }, [data])

  return (
    <>
      <IconButton
        onClick={onClick}
        icon={Download}
        label='Download Referral Fee Breakdown'
      />
      <CSVLink
        ref={csvLinkRef}
        data={data?.data.member_eligibilities ?? []}
        headers={headers}
        filename={`referral_fee_breakdown_${data?.data.employer_name ?? ''}_${data?.data.month ?? ''}.csv`}
        target='_blank'
        className='hidden'
      />
    </>
  )
}

export default DownloadTopUpBreakdownButton
